<style lang="scss">
  .number-inner {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";

  // Utils
  import { derived } from "svelte/store";
  import { relativeLocalDateTimeString } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { MessagePhoneStore } from "./utils";
  // Components
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get stores from context
  const { activityFeedStore, candidatePhoneStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  // Set a local derived store to handle last messaged phone numbers
  // This will be the same as the candidatePhoneStore if no activity feed
  // This has to be defined in this svelte file to be reactive
  const messagePhoneStore = derived(
    [activityFeedStore, candidatePhoneStore],
    ([$activityFeedStore, $candidatePhoneStore]) =>
      MessagePhoneStore($activityFeedStore, $candidatePhoneStore)
  );

  // Props
  export let kind = ""; // 'sms' or 'whatsapp'
  export let onPhoneClick; // Function to handle phone click, passed from parent

  // Function to generate shared ListItem props
  const getListItemProps = (phoneObj) => ({
    onclick: () => onPhoneClick(phoneObj.phone),
    icon: `fa-regular ${phoneObj.kind === "mobile" ? "fa-mobile" : "fa-phone"}`,
  });
</script>

{#each $messagePhoneStore as phoneObj}
  {@const listItemProps = getListItemProps(phoneObj)}
  {#if phoneObj.lastMessaged[kind]}
    <ListItem {...listItemProps} placement="right">
      <span slot="tooltip">
        {relativeLocalDateTimeString(phoneObj.lastMessaged[kind])}
      </span>
      <div class="number-inner">
        {phoneObj.phone}
        <StatusTag
          kind="success"
          size="small"
          leadingIcon="fa-regular fa-check-double"
        >
          Messaged
        </StatusTag>
      </div>
    </ListItem>
  {:else}
    <ListItem {...listItemProps}>
      <div class="number-inner">
        {phoneObj.phone}
      </div>
    </ListItem>
  {/if}
{/each}
